module.exports = __webpack_public_path__ + "static/media/undraw_interview_rmcf.861324b7.svg";